import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { getPurchaseMotionsByLocation } from 'pricing-pages-lib/api/PurchaseMotionsApi';
import { fetchUpgradeConfig } from 'pricing-pages-lib/api/fetchUpgradeConfig';
import { MERCH_CARD } from 'pricing-pages-lib/constants/PurchaseMotionsLocations';
import { getQueryParams } from 'pricing-pages-lib/utils/queryParamUtils';
import { useEffect, useState } from 'react';
import { CRM_SUITE_STARTER_BUNDLE } from 'self-service-api/constants/ApiNames';
import { marketingPricing } from 'self-service-api/core/utilities/links';
import { getIsFreePortalAndOwnedProducts } from 'ui-addon-upgrades/_core/common/eligibility/getIsFreePortal';
import { getPrioritizedUpgradeProductFromApiName } from 'ui-addon-upgrades/ums/getPrioritizedUpgradeProduct';
import ProductInfoContainer from '../common/ProductInfoContainer';
import WhyGoHubSpotSection from '../free-tools-page/WhyGoHubSpotSection';
import PersonalizedFeatureTableContainer, { isEligibleForFeatureTable } from './PersonalizedFeatureTableContainer';
import UpgradeModalHeroBanner from './UpgradeModalHeroBanner';
import ComparePlansLink from './suite-starter-page/ComparePlansLink';
import FeatureInterestAndLimitUsageSection from './suite-starter-page/feature-interest/FeatureInterestAndLimitUsageSection';
const NAV_UPGRADE_SOURCE = 'global-nav-bar';

const PersonalizedPricingPageApp = () => {
  const upgradeSource = getQueryParams().upgradeSource;
  const [data, setData] = useState();
  useEffect(() => {
    if (upgradeSource === NAV_UPGRADE_SOURCE) {
      setData({
        upgradeConfig: null,
        upgradePointApiName: CRM_SUITE_STARTER_BUNDLE,
        error: null
      });
    } else {
      Promise.all([fetchUpgradeConfig(upgradeSource), getIsFreePortalAndOwnedProducts(), getPurchaseMotionsByLocation([MERCH_CARD])]).then(([upgradeConfigResponse, isFreePortalAndOwnedProducts, merchCardPurchaseMotions]) => {
        const {
          recommendationResponse
        } = upgradeConfigResponse;
        const recommendedHub = recommendationResponse ? recommendationResponse.hubType : undefined;
        const selectedApiName = getPrioritizedUpgradeProductFromApiName(upgradeConfigResponse.apiNames, merchCardPurchaseMotions.locations[MERCH_CARD].purchaseMotions, isFreePortalAndOwnedProducts.ownedProducts, isFreePortalAndOwnedProducts.isFreePortal, recommendedHub);

        if (!selectedApiName) {
          throw new Error('No upgrade point apiName found');
        }

        setData({
          upgradeConfig: upgradeConfigResponse,
          upgradePointApiName: selectedApiName,
          error: null
        });
      }).catch(error => {
        setData({
          error,
          upgradeConfig: null,
          upgradePointApiName: null
        });
      });
    }
  }, [upgradeSource]);

  if (!data) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      minHeight: 200,
      size: "md",
      grow: true
    });
  }

  if (data.error) {
    window.location.href = marketingPricing(upgradeSource);
    return null;
  }

  if (data && data.upgradePointApiName) {
    const {
      upgradePointApiName,
      upgradeConfig
    } = data;
    const isSuiteStarter = upgradePointApiName === CRM_SUITE_STARTER_BUNDLE;
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(UpgradeModalHeroBanner, {
        upgradeConfig: upgradeConfig,
        upgradePointApiName: upgradePointApiName
      }), /*#__PURE__*/_jsxs(ProductInfoContainer, {
        style: {
          margin: 'auto'
        },
        children: [isEligibleForFeatureTable(upgradePointApiName) && /*#__PURE__*/_jsx(ComparePlansLink, {}), isSuiteStarter && /*#__PURE__*/_jsx(FeatureInterestAndLimitUsageSection, {}), isEligibleForFeatureTable(upgradePointApiName) && /*#__PURE__*/_jsx(PersonalizedFeatureTableContainer, {
          upgradePointApiName: upgradePointApiName
        }), isSuiteStarter && /*#__PURE__*/_jsx(WhyGoHubSpotSection, {
          selectedNavItem: "suite-starter"
        })]
      })]
    });
  }

  return null;
};

export default PersonalizedPricingPageApp;